import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { PolicyPageData } from '../generic-page.resolver';

@Component({
  selector: 'app-generic-page-type01',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink, NgIf],
  templateUrl: './generic-page-type01.component.html',
  styleUrl: './generic-page-type01.component.scss'
})
export class GenericPageType01Component implements OnInit {

  public view: any = {
    page: {}
  };

  /** When set (from route resolver), use this instead of fetching — ensures fast first paint and SSR */
  @Input() set policyData(data: PolicyPageData | null) {
    if (!data) return;
    this.view.site = data.site;
    if (data.page) {
      this.view.page = data.page;
      this._cd?.markForCheck();
    }
  }

  constructor(
    public _tfmService: TFMService,
    private _cd: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(res => {
      this.view.slug = (res['slug'] || '').toLowerCase();
    });
  }

  ngOnInit(): void {
    if (this.view.page && Object.keys(this.view.page).length > 0 && this.view.site) {
      return;
    }
    this._tfmService.getSite().then(res => {
      this.view.site = res;
      this._cd?.markForCheck();
    });
    if (this.view.slug) {
      this._tfmService.getPages().then((resPages: any) => {
        const pages = (resPages?.content || []).filter((x: any) => x?.seo?.alias?.toLowerCase() === this.view.slug);
        if (pages.length === 1) {
          this.view.page = pages[0];
          this._cd?.markForCheck();
        }
      });
    }
  }
}
